module.exports = __webpack_public_path__ + "static/img/微信图片_20220709152317.bd5758f2.jpg";